<template>
  <h2 v-if="header">{{ header }}</h2>
  <div
    v-if="items == 0 && listItems && listItems.length > 0 && totalMatching > 10"
    class="visually-hidden total"
    aria-live="polite"
    tabindex="-1"
  >
    {{ totalMatchingText }}
  </div>
  <List
    v-if="listItems && listItems.length"
    :listItems="listItems"
  ></List>
  <div class="merlank" v-if="linkUrl && texts && items > 0">
    <a :href="linkUrl">{{ texts.linkText }}</a>
  </div>
  <Pagination
    v-if="items == 0 && listItems && listItems.length > 0 && totalMatching > 10"
    :totalMatching="totalMatching"
    :labels="texts"
    @changePage="onChangePage"
  ></Pagination>
</template>

<script>
import List from "./components/list.vue";
import Pagination from "common/js/vue/pagination/pagination.vue";
import listservice from "../plugins/listservice";

export default {
  name: "ListBlock",
  props: {
    baseApiUrl: String,
    id: String,
    header: String,
    type: String,
    site: String,
    items: Number,
    linkUrl: String,
    texts: Object,
  },
  data: function () {
    return {
      take: 10,
      listItems: undefined,
      totalMatching: 0,
      totalMatchingText: "",
    };
  },
  components: {
    List,
    Pagination,
  },
  created() {
    this.$.appContext.app.config.globalProperties = {
      $texts: this.texts,
    }

    this.take = this.items == 0 ? 10 : this.items;
    let page = 1;
    if (this.items == 0) {
      page = this.getPage();
      this.texts.sidor = this.texts.sidor + " " + this.header;
    }
    this.getItems(page);
  },
  methods: {
    getItems(page) {
      let skip = (page - 1) * this.take;
      listservice
        .getItems(this.baseApiUrl, this.type, this.site, skip, this.take)
        .then((result) => {
          if (result && result.status == 200) {
            this.listItems = result.data.listItems;
            this.totalMatching = result.data.totalMatching;

            if (this.items == 0 && this.totalMatching > 10) {
              let start = (page - 1) * this.take + 1;
              let end =
                page * this.take <= this.totalMatching
                  ? page * this.take
                  : this.totalMatching;

              this.totalMatchingText = `${this.texts.visar} ${start}-${end} ${this.texts.av} ${this.totalMatching}`;
            }
          }
        });
    },
    getPage() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("page") != null
        ? parseInt(urlParams.get("page"))
        : 1;
    },
    onChangePage(page) {
      this.getItems(page);
      let block = document.getElementById(this.id);
      let total = block.querySelector(".visually-hidden.total");
      total.focus();
    },
  },
};
</script>
